import { render, staticRenderFns } from "./indexEx.vue?vue&type=template&id=1304783f&"
import script from "./indexEx.vue?vue&type=script&lang=js&"
export * from "./indexEx.vue?vue&type=script&lang=js&"
import style0 from "./indexEx.vue?vue&type=style&index=0&id=1304783f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports